<template>
	<div class="leftTopLi" :style="{backgroundImage: 'url(' + borderBack + ')'}">
		<div class="leftTopti">
			<img src="../../../../static/imgV2/index-course.png" alt="">
			<div style="margin-left: 10px;text-align: left;">
				<div>{{ languageJson.InspectionMileage }}</div>
				<div><span style="font-size: 1.1vw;">{{ runCountVo.totalMileage }}</span>{{ languageJson.KM }}</div>
			</div>
		</div>

		<div class="leftTopti">
			<img src="../../../../static/imgV2/index-time.png" alt="">
			<div style="margin-left: 10px;text-align: left;">
				<div>{{ languageJson.systemRuntime }}</div>
				<div><span style="font-size: 1.1vw;">{{ ((new Date() - Number(runCountVo.tenantStarTime))/1000/60/60).toFixed(2) }}</span>{{ languageJson.hour }}</div>
			</div>
		</div>

		<div class="leftTopti backImg" :style="{backgroundImage: 'url(' + timeBg + ')'}">
			<div style="margin-left: 10px;">{{ languageJson.AccumulatedReporting }}</div>
			<div style="margin-right: 10px;">{{ runCountVo.totalEvent }}</div>
		</div>

		<div class="leftTopti backImg" :style="{backgroundImage: 'url(' + timeBg + ')'}">
			<div style="margin-left: 10px;">{{ languageJson.InspectionClockin }}</div>
			<div style="margin-right: 10px;">{{ runCountVo.patrolEvent }}</div>
		</div>

		<div class="leftTopti backImg" :style="{backgroundImage: 'url(' + timeBg + ')'}">
			<div style="margin-left: 10px;">{{ languageJson.ProactivelyReporting }}</div>
			<div style="margin-right: 10px;">{{ runCountVo.reportEvent }}</div>
		</div>
	</div>
</template>

<script>
	import {
		runEventCount
	} from '@/api/indexV2'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		name: 'login',
		data() {
			return {
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
				borderBack: require('../../../../static/imgV2/bg.png'),
				timeBg: require('../../../../static/imgV2/index-green.gif'),
				runCountVo: {
					patrolEvent: "",
					reportEvent: "",
					tenantStarTime: "",
					totalEvent: "",
					totalMileage: ""
				}
			}
		},
		props: {
			changeTime: Boolean
		},
		mounted() {
			let that = this
			that.runEventCount()
		},
		methods: {
			runEventCount() {
				let that = this
				runEventCount(getItem('tenantInfoId')).then(res => {
					if (res && res.data) that.runCountVo = res.data
				})
			}
		},
		watch: {
			changeTime: {
				deep: true,
				immediate: false,
				handler(newData, oldData) {
					this.runEventCount()
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.leftTopLi {
		position: absolute;
		width: 20%;
		height: 80%;
		top: 4%;
		left: 2%;
		color: white;
		text-shadow: 0px 2px 4px rgba(0,29,95,0.5);
		background: linear-gradient(180deg, #FFFFFF 0%, #9FE3FF 100%);
		font-size: 0.8vw;
		font-weight: 700;
		background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;

		.leftTopti {
			width: 80%;
			margin: 0 auto;
			display: flex;
			align-items: center;

			img {
				width: 20%;
			}
		}
		.backImg {
			background-size: 100% 100%;
			padding: 0.6vw 0;
			justify-content: space-between;
		}
	}

</style>



// WEBPACK FOOTER //
// src/page/customIndex/components/leftTop.vue